/* src/app/shared/components/ag-add-icon-lib/ag-add-icon-lib.component.scss */
.header {
  display: flex;
  flex-direction: row;
  padding: 24px;
  border-bottom: 1px solid #dfdfdf;
}
.img-list {
  padding: 24px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  height: 428px;
  overflow: scroll;
}
.img-list img {
  border-radius: 8px;
}
.bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px;
  border-top: 1px solid #dfdfdf;
}
.blue-highlight {
  outline: 2px solid #6e89da;
  border-radius: 8px;
}
/*# sourceMappingURL=ag-add-icon-lib.component.css.map */
